import React, { useEffect, useState } from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';

import images1 from '../../assets/images/image2.jpg';
import { images } from '../../assets/images';
import EqualHeightElement from 'react-equal-height';
import PageTitle from '../../Components/PageTitle';
import Events from './Events_side';
import { routes } from '../../routes';
import NewsController from '../../apis/controller/news.controller';
import { renderImage } from '../../Components/helper/image';
import { dateFormat } from '../../Components/helper/date';
import { charLimit, stripTags } from '../../Components/helper/General';

function Newsdetail() {
    const [newsDetail, setNewsDetail] = useState();
    const [loader, setLoader] = useState(false);
    let param = useParams();
    useEffect(() => {
        getNewsDetails();
        window.scrollTo(0, 0);
    }, [param.slug]);

    const getNewsDetails = async () => {
        setLoader(true);
        let res = await new NewsController().newsDetail(param.slug);
        if (res && res.status) {
            setNewsDetail(res);
        }
        setLoader(false);
    };
    return (
        <>
            <PageTitle title="News Detail" />
            {newsDetail ? <section className="blog_detail_section">
                <div className="container">
                    <div className="row">
                        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                            <div className="blog_detail_area">
                                <div className="row">
                                    <div className="col-xxl-8 col-xl-8 col-lg-8 col-md-12 col-sm-12 col-12">
                                        <div className="blog_detail_content">
                                            <div className="img_area">
                                                <img src={renderImage(newsDetail.news.image, 'large')} />
                                            </div>
                                            <div className="date">{dateFormat(newsDetail.created)}</div>
                                            <div className="content_box">
                                                <h6>
                                                    {newsDetail.news.title}
                                                </h6>
                                                <div dangerouslySetInnerHTML={{ __html: newsDetail.news.description }} />
                                            </div>
                                            <div className="share">
                                                <ul>
                                                    <li>
                                                        Share:
                                                    </li>
                                                    <li>
                                                        <Link to=""><i className="fab fa-facebook-f"></i></Link>
                                                    </li>
                                                    <li>
                                                        <Link to=""><i className="fab fa-twitter"></i></Link>
                                                    </li>
                                                    <li>
                                                        <Link to=""><i className="fab fa-instagram"></i></Link>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12">
                                        <div className="blog_sidebar">
                                            <div className="tags_box">
                                                <h6>Top Categories</h6>
                                                <ul className="list-inline">
                                                    {newsDetail.category.map((item, index) => (
                                                        <>
                                                            {item.active === 1 ? (<li key={index} className="active">
                                                                <Link to={`/news/${item.id}`}>{item.title}</Link>
                                                                <div className="cross_icon">
                                                                    <i className="lnr lnr-cross"></i>
                                                                </div>
                                                            </li>)
                                                                :
                                                                (<li key={index}>
                                                                    <Link to={`/news/${item.id}`}>{item.title}</Link>
                                                                    <div className="cross_icon">
                                                                        <i className="lnr lnr-cross"></i>
                                                                    </div>
                                                                </li>)}
                                                        </>
                                                    ))}
                                                </ul>
                                            </div>
                                            <Events item={newsDetail.recent_post} getNewsDetail={(e) => getNewsDetails(e)} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section> : null}

            {newsDetail ? <section className="frome-blog blog-space">
                <div className="container">
                    <div className="row">
                        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                            {newsDetail.relatedNews.length > 0 ? <div className="heading-lines ps-0">
                                <h2>
                                    Related Posts
                                </h2>
                            </div> : null}
                            <div className="blog_wrap">
                                <div className="news_listing pt-4">
                                    <div className="row">
                                        {newsDetail.relatedNews.map((item, index) => (
                                            <div key={index} className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                                                <div className="news_item">
                                                    <div className="img_area embed-responsive embed-responsive-4by3">
                                                        <img src={renderImage(item.image)} className="embed-responsive-item img-fluid" alt="..." />
                                                        <div className="upper_img">
                                                            <div className="secondary_btn" >
                                                                <Link to={"#"}>
                                                                    <div onClick={() => getNewsDetails(item.id)}>
                                                                        Read More
                                                                    </div>
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="news_info">
                                                        <div className="d-flex align-items-center justify-content-between mb-2">
                                                            {item.categories.map((item, index) => (
                                                                <div key={index} className="news_catg">
                                                                    <Link to={`/newsdetail/${item.slug}`}>{item.title}</Link>
                                                                </div>
                                                            ))}
                                                        </div>
                                                        <h5>
                                                            <Link to={`/newsdetail/${item.slug}`}>{item.title}</Link>
                                                        </h5>
                                                        <p>
                                                            {charLimit(stripTags(item.description), 225)}
                                                        </p>
                                                        <hr />
                                                        <div className="news_metainfo">
                                                            <ul>
                                                                <li>
                                                                    <i className="far fa-user"></i>
                                                                    <span>By {item.owner.first_name} {item.owner.last_name}</span>
                                                                </li>
                                                                <li>
                                                                    <i className="far fa-calendar"></i>
                                                                    <span>{dateFormat(item.created)}</span>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section> : null}
        </>
    );
}

export default Newsdetail;
